import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { option } from 'fp-ts';
import { flow } from 'fp-ts/function';
import { createSelector } from 'reselect';

import { getOrFalse } from '@mews/fp';

import { ApplicationState } from '../../types';

import { moduleId } from './constants';
import { Rates } from './types';

const ratesInitialState: Rates = {
    fetchPricingTimeoutId: null,
    hasPreparationFailed: false,
    isPreparing: false,
};

const ratesSlice = createSlice({
    name: 'rates',
    initialState: ratesInitialState,
    reducers: {
        ratesPreparationStarted: (state) => {
            state.hasPreparationFailed = false;
            state.isPreparing = true;
        },
        ratesPreparationSucceeded: (state) => {
            state.hasPreparationFailed = false;
            state.isPreparing = false;
        },
        ratesPreparationFailed: (state) => {
            state.hasPreparationFailed = true;
            state.isPreparing = false;
        },
        setFetchPricingTimeoutId: (state, { payload: timeoutId }: PayloadAction<number | null>) => ({
            ...state,
            fetchPricingTimeoutId: timeoutId,
        }),
    },
});

export const { setFetchPricingTimeoutId, ratesPreparationFailed, ratesPreparationStarted, ratesPreparationSucceeded } =
    ratesSlice.actions;

const moduleSelector = (state: ApplicationState) => state[moduleId];

export const getFetchPricingTimeoutId = flow(
    moduleSelector,
    ({ fetchPricingTimeoutId }) => fetchPricingTimeoutId,
    option.fromNullable
);

export const isFetchPricingTimeoutIdSome = flow(getFetchPricingTimeoutId, option.isSome);
export const areRatesPreparing = createSelector(moduleSelector, getOrFalse('isPreparing'));
export const hasRatesPreparationFailed = createSelector(moduleSelector, getOrFalse('hasPreparationFailed'));

export const { reducer: ratesReducer } = ratesSlice;
